import "./TitleSelector.css";
import * as React from "react";
import { Button } from "semantic-ui-react";
import { validation } from "../../utils/validation/validation";

interface ITitleSelectorProps {
  onClick(value: any): void;
  showTitleNotSelectedError: boolean;
  titles: Array<string>;
  selectedTitle: string;
  cssClasses: string;
  validate(): void;
}

interface ITitleSelectorState {
  title: string;
  showTitleNotSelectedError: boolean;
}

export class TitleSelector extends React.Component<
  ITitleSelectorProps,
  ITitleSelectorState
> {
  state: ITitleSelectorState;

  constructor(props: ITitleSelectorProps) {
    super(props);
    this.state = {
      title: "",
      showTitleNotSelectedError: false
    };
  }

  componentDidUpdate(
    prevProps: ITitleSelectorProps,
    _prevState: ITitleSelectorState,
    _snapshot: any
  ) {
    if (
      prevProps.showTitleNotSelectedError !==
      this.props.showTitleNotSelectedError
    ) {
      this.setState({
        showTitleNotSelectedError: this.props.showTitleNotSelectedError
      });
    }
  }
  renderButtons = () => 
    (this.props.titles || []).map((item, idx) => (
      <Button
        key={idx}
        type="button"
        value={item}
        className={this.state.title === item ? "active" : ""}
        onClick={(event: any) => {
          event.preventDefault();
          this.setState({
            title: event.currentTarget.value
          });
          this.props.onClick(this.state.title);
            
          this.setState({
            showTitleNotSelectedError: validation.isEmpty(this.state.title)
          });
        }}
      >
        {item}
      </Button>
    ));
  
  render() {
    return (
      <>
        <label>Title</label>
        <Button.Group
          className={
            this.props.cssClasses + (this.state.showTitleNotSelectedError
              ? " titleSelectorError"
              : "")
          }
        >
          {this.renderButtons()}
        </Button.Group>

      </>
    );
  }
}

{/*<Button
        key={idx}
        type="button"
        value={item}
        className={this.state.title === item ? "active" : ""}
        onClick={(event: any) => {
          event.preventDefault();
          this.setState({
            title: event.currentTarget.value
          });
          this.props.onClick(this.state.title);

          this.setState({
            showTitleNotSelectedError: validation.isEmpty(this.state.title)
          });
        }}
      >
        {item}
      </Button>*/}
